import { render, staticRenderFns } from "./AdminManagement.vue?vue&type=template&id=4e7d5118&scoped=true&"
import script from "./AdminManagement.ts?vue&type=script&lang=ts&"
export * from "./AdminManagement.ts?vue&type=script&lang=ts&"
import style0 from "./AdminManagement.vue?vue&type=style&index=0&id=4e7d5118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7d5118",
  null
  
)

export default component.exports